
import React from 'react';
import { Name } from "../prm/name";
import { FlowRender } from "../flow-render";
import { Text, floatValidator } from "../prm/text";
import { RadioButton, RADIO_SINGLE_RANDOM_VALUE } from "../prm/radio-button";
import faker from "faker";
import { sprintf } from "sprintf-js";
import {Info} from "../../client/funcs/utils";
import {deep_copy} from "../js-utils";
import {is_ira as is_ira_f } from "../onboarding-utils";

const crypto_invest = new RadioButton(
  new Name("crypto_invest"),
  [
    new Name("no", "No, cryptocurrencies are too risky"),
    new Name("yes", "Yes"),
  ], [], RADIO_SINGLE_RANDOM_VALUE);

const crypto_agree = new RadioButton(
  new Name("crypto_agree"),
  [
    new Name("agree", "Agree")
  ]);
crypto_agree.do_checkbox = true;

const crypto_amt = new Text(
  new Name("crypto_amt"));
crypto_amt.setValidator(floatValidator);

class Crypto extends FlowRender {

  constructor(index) {
    super(index, [
      crypto_invest,
      crypto_agree,
      crypto_amt,
    ]);
    crypto_invest.onChangeCallback = this.onChange;
    crypto_agree.onChangeCallback = this.onChange;
    crypto_amt.onChangeCallback = this.onChange;
    this.url = "crypto";
  }

  init(componentState, appState) {
    super.init(componentState, appState);
    componentState.show_crypto_popup = false;
    componentState.show_esg = false;
    componentState.show_capped = false;
  }

  onChange = (component, newState) => {
    const is_agree_clicked = crypto_agree.isItemClicked(0, newState);
    crypto_amt.setDisabled(newState, !is_agree_clicked);
  }

  onFinish = (component) => {
    if (component.state.dirty) {
      component.props.clearOnboardingItem(
        component.getOnboardingIndex(), ["alloc"], component.props.username);
    }
  }

  canNavigateNext(component) {
    const highlight_rects = [];
    const state = component.state;
    const is_ira = is_ira_f(component.getOnboardingData());

    crypto_invest.isFilledElseHighlight(state, highlight_rects);

    if (crypto_invest.isItemClicked(1, state)) {
      crypto_agree.isFilledElseHighlight(state, highlight_rects);
      crypto_amt.isFilledElseHighlight(state, highlight_rects);
      if (!crypto_amt.isBlank(state)) {
        let amt = parseFloat(crypto_amt.getValue(state));
        let capped = false;

        if (amt < 0.) {
          amt = 0;
          capped = true;
        } else if (amt > 5.) {
          amt = 5.;
          capped = true;
        }

        if (capped) {
          const new_state = deep_copy(component.state);
          new_state.show_capped = true;
          crypto_amt.setValue(new_state, sprintf("%d", amt));
          component.setState(new_state);
          return null;
        }
      }
    }

    component.setState({ highlight_rects });
    if (highlight_rects.length === 0) {
      return is_ira
        ? component.getRootUrl() + "/tax_attestation"
        : component.getRootUrl() + "/summary";
    }
  }

  setRandomValues(state, component) {
    super.setRandomValues(state, component);
    const crypto_clicked = crypto_invest.isItemClicked(1, component.state);

    crypto_agree.setValues(state, ["agree"], crypto_clicked);

    if (crypto_clicked) {
      const num = faker.random.number({ min: 0.1, max: 5., precision: 0.1});
      crypto_amt.setValue(state, sprintf("%.1f", num));
    } else {
      crypto_amt.setValue(state, "");
    }
  }

  renderCheckbox = (component, prm, index, body, onMouseOver, popup) => {
    const container_style = {
      padding: "0.5rem 0",
      display: "flex",
      alignItems: "top",
    }
    const checkbox_container = {
      padding: "0.4rem 1rem",
    }
    // const onMouseEnter = onMouseOver ? onMouseOver(true) : () => {};
    // const onMouseLeave = onMouseOver ? onMouseOver(false) : () => {};

    return (
      <div style={container_style}>
        <div style={checkbox_container}>
          { prm.renderRadioLabel(index, component) }
        </div>
        {/* <div
          style={{ paddingTop: "0.2rem"}}
          onMouseEnter={onMouseEnter}
          onMouseLeave={onMouseLeave}>
          <span>{ prm.buttonList[index].label}</span>
          { popup }
        </div> */}
        <div>
          { body }
        </div>
      </div>
    )
  }

  renderCryptoYes = component => {
    const text = "I understand that I may lose some or all of my cryptocurrency investment.";
    const is_yes_clicked = crypto_invest.isItemClicked(1, component.state);

    const container_style = {
      padding: "0 2rem",
      visibility: is_yes_clicked ? "visible" : "hidden",
    }
    const capped_style = {
      visibility: component.state.show_capped ? "visible" : "hidden",
      color: "red",
      fontSize: "1.2rem",
      paddingLeft: "2rem",
    }
    
    return (
      <div style={container_style}>
        <div style={{padding: "0.5rem 0"}}>
          <span>{text}</span>
        </div>
        <div style={{display: "flex", alignItems: "center"}}>
          <div style={{paddingRight: "0.5rem"}}>
            { crypto_agree.renderRadioLabel(0, component, { transform: "translate(0, 0)" }) }
          </div>
          {/* <div style={{paddingRight: "2rem"}}>
            <span>Agree</span>
          </div> */}
          <div style={{paddingRight: "0.5rem"}}>
            { crypto_amt.renderInput(component, { width: "5rem", textAlign: "center"}) }
          </div>
          <div>
            %
          </div>
          <div style={capped_style}>
            Capped at 5%
          </div>
        </div>
      </div>
    )
  }

  onMouseOver = (component, param) => (over) => ev => {
    component.setState({
      [param]: over,
    })
  }

  renderCryptoInfo = component => {
    const text_0 = "Cryptocurrency Assets";
    const text_3 = "Investing in cryptocurrency assets involves a high degree of risk and is not "
      + "suitable for all investors. Before deciding to invest in digital assets you should carefully "
      + "consider the potential of losing 100% of your investment.";

    const popup_style = {
      width: "40rem",
      border: "2px solid black",
      padding: "1rem",
    }

    const card = (
      <div style={{fontSize: "0.9rem"}}>
        <p style={{ fontWeight: "bold" }}>{text_0}</p>
        <div style={{height: "1rem"}}/>
        <p>{text_3}</p>
      </div>
    )
    return (
      <Info
        id={"on_crypto_over"}
        component={component}
        text={card}
        popup_style={popup_style} />);
  }

  renderESGInfo = component => {

    const text_0 = "Socially Responsible Investing also known as ESG:";
    const text_4 = "Businesses that incorporate ESG practices may avoid environmental, " +
        "legal and regulatory consequences, and possibly outperform peers over the long run.";
    const text_5 = "However, ESG portfolio performance may lag relative to other investment portfolios " +
        "as ESG portfolios may be more expensive to construct, ESG businesses may have costlier " +
        "standards of operation, and there are fewer high ESG grade investable enterprises.";

    const popup_style = {
      width: "40rem",
      border: "2px solid black",
      padding: "1rem",
      fontSize: "0.9rem",
      right: "0",
    }

    const card =  (
      <div style={{fontSize: "0.9rem"}}>
        <p style={{ fontWeight: "bold" }}>{text_0}</p>
        <div style={{height: "1rem"}}/>
        <p>{text_4}</p>
        <div style={{height: "1rem"}}/>
        <p style={{fontWeight: "bold"}}>{text_5}</p>
      </div>
    )

    return (
      <Info
        id={"on_esg_over"}
        component={component}
        text={card}
        popup_style={popup_style}/>
    );
  }

  renderBody = component => {
    const crypto_text = "Do you want up to 5% of your portfolio invested in cryptocurrency assets?";

    return (
      <div>
        <div style={{fontSize: "1.5rem"}}>
          <span>{crypto_text}</span> { ' ' }
          { this.renderCryptoInfo(component)}
        </div>
        <div style={{height: "1rem"}}/>
        { this.renderCheckbox(component, crypto_invest, 0)}
        { this.renderCheckbox(
          component, crypto_invest, 1, this.renderCryptoYes(component)) }
        <div style={{height: "1rem"}}/>
      </div>
    )
  }

  render = component => {
    return (
      <div>
        { this.renderHighlightRects(component) }
        { this.renderTitle(component, "Alternative Investments", "50%", "952128799")}
        { this.renderProgress(component) }
        { this.renderSingleColumn(
          this.renderBody(component), "50%")}
        { this.renderNextButtonRow(component, true) }
      </div>
    )
  }
}

export { Crypto };
